import React, {useState, useEffect} from 'react';
import {Spinner} from 'reactstrap';

export const ModalActivarServicio = (props) => {
	/* Destructuring the props object. */
	const {setEstadoModal} = props;

	/* A hook that is used to set the state of the component. */
	const [EstadoModalInterno, setEstadoModalInterno] = useState(0);

	/**
	 * It sets the state of the modal to 0.
	 */
	const volver = () => {
		setEstadoModal(0);
	};
	/**
	 * It fetches the youtube.com website.
	 */
	async function activarServicio() {
		try {
			let ss = await fetch('https://www.youtube.com/');
		} catch (e) {
			console.error('error envio datos [enviarPresupuesto]');
		}
		setEstadoModalInterno(1);
	}

	/**
	 * It sets the state of the modal to 3.
	 */
	const generarInformes = () => {
		setEstadoModal(3);
	};

	/* Calling the `activarServicio()` function. */
	useEffect(() => {
		activarServicio();
	}, []);

	return (
		<div className='modalBaseFondoGD'>
			{EstadoModalInterno === 0 ? (
				<div className='modalBaseGD'>
					<div>
						<Spinner />
					</div>
				</div>
			) : EstadoModalInterno === 1 ? (
				<div className='modalBaseGD'>
					<div>Servicio activado con exito</div>
					<div>¿Desea generar un informe?</div>
					<div className='botonesGenerarInforme'>
						<div
							className='button'
							onClick={() => volver()}
						>
							<b>Volver</b>
						</div>
						<div
							className='button'
							onClick={() => generarInformes()}
						>
							<b>Generar Informe</b>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};
